<h1 class="areaHeading pt-5 pb-2 mt-5">Certificates</h1>

<div class="flex-container">
    <div class="flex-item carousel-img">
        <div class="card">
            <ngb-carousel #carousel [interval]="3000" class="card-shadow" style="border-radius: 3px;">
                <ng-template ngbSlide *ngFor="let img of images | async">
                        <mat-spinner *ngIf="loading" class="mat-spinner-color"></mat-spinner>
                        <img [hidden]="loading" (load)="onLoad()" class="carousal-img" [src]="img.src" alt="{{ img.title }}">
                </ng-template>
            </ngb-carousel>
        </div>
    </div>
    <div class="flex-item">
        <div class="card">
            <mat-spinner *ngIf="loadingtopSideImage" class="mat-spinner-color"></mat-spinner>
            <img [hidden]="loadingtopSideImage" (load)="onLoadTopSideImage()" class="carousal-img" [src]="rightimg.src" alt="{{ rightimg.title }}" width="100%" height="auto">
        </div>
        <div class="card mt-2">
            <mat-spinner *ngIf="loadingBottomSideImage" class="mat-spinner-color"></mat-spinner>
            <img [hidden]="loadingBottomSideImage" (load)="onLoadBottomSideImage()" class="carousal-img" [src]="rightimgBottom.src" alt="{{ rightimgBottom.title }}" width="100%" height="auto">
        </div>
    </div>
</div>